function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "ICON/Search");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Header2_SP-Search",
  transform: "translate(-607.000000, -19.000000)",
  fill: "#8D8E99",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "ICON/Magnify-Search",
  transform: "translate(607.000000, 19.250000)"
}, React.createElement("path", {
  d: "M4.5,0.5625 C2.07685066,0.5625 0.1125,2.52685066 0.1125,4.95 C0.1125,7.37314934 2.07685066,9.3375 4.5,9.3375 C6.92314934,9.3375 8.8875,7.37314934 8.8875,4.95 C8.8875,2.52685066 6.92314934,0.5625 4.5,0.5625 Z M4.5,2.1375 C6.05330086,2.1375 7.3125,3.39669914 7.3125,4.95 C7.3125,6.50330086 6.05330086,7.7625 4.5,7.7625 C2.94669914,7.7625 1.6875,6.50330086 1.6875,4.95 C1.6875,3.39669914 2.94669914,2.1375 4.5,2.1375 Z",
  id: "Oval"
}), React.createElement("polygon", {
  id: "Path-7",
  points: "7.31092101 6.64725786 12.4645687 11.8771635 11.3427266 12.9826478 6.18907899 7.75274214"
}))));

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "13px",
    height: "14px",
    viewBox: "0 0 13 14",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.09694a48.svg";
export { ForwardRef as ReactComponent };